import { ErrorInformation, message } from "digital-core";

export class LogInformation extends ErrorInformation {
    ApplicationId: string;
    ClientId?: string;

    constructor(code: string, message: string, StackTrace: string, details: string, action: string, level: string, audience: string, ApplicationId: string) {
        super(code, message, StackTrace, details, action, level, audience);
    }

}